import * as tracking from '../../../../tracking';
import {
	BUTTON_COLOR,
	BUTTON_STYLE,
	ELEMENT_TYPE,
	EMPTY_STATE,
	FEATURE_FLAGS,
	FILTER_SECTION,
	FILTER_TYPE,
	HIDDEN_FEATURES,
	MODULE_TYPES,
	PROJECT_STATUS,
	SOCKET_ACTION,
	SOCKET_EVENT_TYPE,
} from '../../../../constants';
import {MODAL_TYPE, showModal} from '../../../shared/components/modals/generic_modal_conductor';
import React, {Component} from 'react';
import {cloneDeep} from 'lodash';
import ProjectListDoneProjectsEmptyState from './ProjectListDoneProjectsEmptyState';
import EmptyState from '../../../shared/components/empty-states/empty_state';
import HeaderBar from '../../../shared/components/headers/header-bar/header_bar';
import {Link, withRouter} from 'react-router-dom';
import ProjectListConnectedProjectLineItem from './ProjectListConnectedProjectLineItem';
import ProjectListProjectLineItem from './ProjectListProjectLineItem';
import ProjectListProjectCard from './ProjectListProjectCard';
import {createRefetchContainer, graphql} from 'react-relay';
import {UploadingOverlay} from '../../../shared/components/uploading-overlay/UploadingOverlay';
import Util from '../../../shared/util/util';
import util from '../../../shared/util/util';
import {injectIntl} from 'react-intl';
import {withSocketHandling} from '../../../../socket/withSocketHandling';
import {getOrderedFilters} from '../../../shared/components/filters/filter_util';
import {FILTER_SECTIONS} from '../../../shared/components/filters/dropdown_section';
import {DEFAULT_STAGE_BAND_CONNECTION} from '../../../opportunities-tab/opportunityStage';
import {buildProjectListFilterFunctions} from './projectListFilters';
import {hasTimeApproval} from '../../../shared/util/FeatureUtil';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../shared/components/headers/top-header-bar/TopHeaderBar';
import DirectApi from '../../../../directApi';
import {hasAiAccess, hasPermission, hasSomePermission, isClientUser} from '../../../shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../../Permissions';
import {LoadMore} from '../../../../components/loaders/LoadMore';
import ProjectsLoader, {projectsLoaderQuery} from './ProjectsLoader';
import {sortProjects} from './SortProjects';
import InlineLoader from '../../../shared/components/inline-loader/inline_loader';
import {filterProjects} from './FilterProjects';
import {remapOptionTranslationIds} from '../../../shared/util/FinancialInternationalisationUtil';
import {trackEvent, trackPage, unregisterPageInfo} from '../../../../tracking/amplitude/TrackingV2';
import CompanySetupUtil, {isFeatureHidden} from '../../../shared/util/CompanySetupUtil';
import {hasFeatureFlag, isClientContactsFeatureEnabled} from '../../../shared/util/FeatureUtil';
import ReactVisibilitySensor from 'react-visibility-sensor';
import {hasModule} from '../../../shared/util/ModuleUtil';
import {setQueryInRelayStore, Query} from '../../../shared/util/cache/RelayQueryCache';
import CustomScrollToNativeScroll from '../../../shared/components/scroll-bars/CustomScrollToNativeScroll';
import SageUtil from '../../../shared/util/sage/SageUtil';
import {toCustomFieldColumnDefs} from '../../../shared/components/custom-field-columns/customFieldColumnModel';
import {
	readCustomFieldChoices,
	visibleCustomFields,
	writeCustomFieldChoices,
} from '../../../shared/components/custom-field-columns/customFieldColumnPrefs';
import {decimalSeparatorFor} from '../../../shared/util/customFieldValueValidation';
import {
	PROJECTS_CUSTOM_FIELD_SCOPE,
	applyCustomFieldChoiceAction,
	customFieldColumnsTableStyle,
	customFieldColumnsTableWidthPx,
	customFieldEyeAction,
	customFieldEyeGroup,
	resolveProjectsSortBy,
} from './projectCustomFieldColumns';
import {ProjectCustomFieldHeaderCell} from './ProjectCustomFieldCells';
import {BASELINE_BUILDER_ENTRY_POINT} from '../../../../tracking/amplitude/baselineBuilderEvents';
import {
	isCustomStageKey,
	profileSectionLabel,
	showsOpportunityGroup,
	stageGroupKeyOf,
	stageLabel,
} from '../../../shared/util/projectStageUtil';
import {getProjectStages} from '../../../shared/util/ProjectStageCache';

const getCustomStageSections = props => {
	const stageOf = new Map();
	const visit = project => {
		const key = stageGroupKeyOf(project);
		if (isCustomStageKey(key) && !stageOf.has(key)) {
			stageOf.set(key, project.stage.name ?? '');
		}
	};
	(props.viewer.projects?.edges ?? []).forEach(edge => visit(edge?.node));
	(props.viewer.projectGroups?.edges ?? []).forEach(group =>
		(group?.node?.projects?.edges ?? []).forEach(edge => visit(edge?.node))
	);
	const sortOrders = new Map(getProjectStages().map(stage => [stage.id, stage.sortOrder]));
	const orderOf = key => (sortOrders.has(key) ? sortOrders.get(key) : Infinity);
	return [...stageOf.entries()].sort((a, b) => orderOf(a[0]) - orderOf(b[0])).map(([key, name]) => ({key, name}));
};

// Fields available on the Projects list, A-Z. Empty when the gate is off: the query skips them.
const customFieldDefinitionsOf = props => toCustomFieldColumnDefs(props.viewer.company.projectListCustomFieldDefinitions);

// Saves the unsorted state (UNSORTED: no column, ascending), whenever a custom column the sort was on goes away.
const resetSavedProjectsSort = () => {
	Util.localStorageSetItem('overview-projects-sort-column', '');
	Util.localStorageSetItem('overview-projects-sort-ascending', true);
};

class ProjectListPage extends Component {
	constructor(props) {
		super(props);

		if (props.viewer.company) {
			this.state = this.getOverviewProjectConstructorState(props);
		}

		this.resize = this.resize.bind(this);
		this.handleCustomFieldChoice = this.handleCustomFieldChoice.bind(this);
		this.handleShortcutProjects = this.handleShortcutProjects.bind(this);
		this.hasTimeApproval = hasTimeApproval();

		let columns;
		if (this.state.displayMode === 'list') {
			columns = this.state.columns
				.filter(column => column.checked)
				.map(column => {
					return {name: column.name, checked: column.checked};
				});
		} else {
			columns = this.state.cardLayoutDisplay
				.filter(column => column.checked)
				.map(column => {
					return {name: column.name, checked: column.checked};
				});
		}

		this.superPropertyChecksum = trackPage('Projects', {columns, display: this.state.displayMode});
	}

	componentDidMount() {
		document.title = this.props.intl.formatMessage({id: 'project_overview.document_title'});
		document.addEventListener('keydown', this.handleShortcutProjects);
		if (this.props.viewer.company) {
			this.overviewProjectDidMount(this.props);
		}
		if (this.props.excludeDoneOrHalted && this.props.relay.refetch) {
			this.props.relay.refetch(
				{
					excludeDoneOrHalted: false,
					loadCustomFields: !!this.props.loadCustomFields,
				},
				null,
				() => {
					this.setState({lazyDataFetched: true});
					setQueryInRelayStore(Query.OverviewProjects);
				}
			);
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.state === null && nextProps.viewer.company) {
			const stateObject = this.getOverviewProjectConstructorState(nextProps);
			this.setState(stateObject, () => {
				this.overviewProjectDidMount(nextProps);
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return !!nextProps.viewer.company;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state !== null && prevProps.viewer !== this.props.viewer) {
			this.syncCustomStageSections();
		}
		if (
			this.state !== null &&
			prevProps.viewer.company?.projectListCustomFieldDefinitions !==
				this.props.viewer.company?.projectListCustomFieldDefinitions
		) {
			this.resetUnavailableCustomFieldSort();
			// The stored filter functions hold the definitions they were built with; rebuild them so a field
			// that became available or unavailable is honoured without waiting for the next filter change.
			this.setState({
				filterFunctions: buildProjectListFilterFunctions(this.state.filters, this.getProjectListFilterContext()),
			});
		}
		if (prevState !== null && this.state !== null) {
			// need to handle a case when project status section was expanded.
			let anyProjectStatusExpanded = false;
			let loadedSection = false;
			this.project_statuses.forEach(project_status => {
				if (!anyProjectStatusExpanded) {
					anyProjectStatusExpanded =
						this.state.projectStatusSectionExpandedMap.get(project_status) &&
						!prevState.projectStatusSectionExpandedMap.get(project_status);
					loadedSection = true;
				}
			});
			if (
				anyProjectStatusExpanded ||
				this.state.displayMode !== prevState.displayMode ||
				this.state.searchFilterValue !== prevState.searchFilterValue ||
				this.state.filterChanged
			) {
				const {numberOfProjectTilesAfterLastGroupMap} = this.state;
				this.project_statuses.forEach(project_status => {
					const numberOfProjects = this.getNumberOfExtraMarginProjects(project_status);
					numberOfProjectTilesAfterLastGroupMap.set(project_status, numberOfProjects);
				});
				const stateObject = {numberOfProjectTilesAfterLastGroupMap, filterChanged: false};
				stateObject.loadingSection = !loadedSection;
				this.setState(stateObject);
			}
		}

		if (this.state.searchFilterValue !== prevState.searchFilterValue) {
			if (this.state.searchFilterValue && this.state.searchFilterValue !== '') {
				let projects = [];
				this.props.viewer.projectGroups.edges.forEach(pGroup => {
					projects.push(cloneDeep(pGroup));
				});
				this.props.viewer.projects.edges
					.filter(p => this.props.viewer.client || !p.node.isInProjectGroup)
					.forEach(p => projects.push(p));
				//add projects to list end

				projects = filterProjects(
					projects,
					this.state.searchFilterValue,
					this.state.filters,
					this.state.filterFunctions,
					this.calculatedDataMap
				);
				const projectCount = projects.length;
				trackEvent('Search', 'Results', {searchString: this.state.searchFilterValue, matching: projectCount});
			}
		}
	}

	componentWillUnmount() {
		unregisterPageInfo(this.superPropertyChecksum);

		document.removeEventListener('keydown', this.handleShortcutProjects);
		window.removeEventListener('resize', this.resize);
		cancelAnimationFrame(this.requestedFrame);

		if (this.abortController) {
			this.abortController.abort('Component unmounted. Aborting fetching calculated fields.');
		}
	}

	// Projects of a stage without a profile arrive after the first render (lazy refetch), so the sections follow props.
	syncCustomStageSections() {
		const customSections = getCustomStageSections(this.props);
		const current = this.project_statuses.filter(isCustomStageKey);
		if (customSections.length === current.length && customSections.every((section, i) => section.key === current[i])) {
			return;
		}
		this.customStageNames = new Map(customSections.map(section => [section.key, section.name]));
		this.project_statuses = [
			...this.project_statuses.filter(status => !isCustomStageKey(status)),
			...customSections.map(section => section.key),
		];
		const {projectStatusSectionExpandedMap, projectSectionCardHeightMap, numberOfProjectTilesAfterLastGroupMap} =
			this.state;
		const isChecked = name => !!this.state.cardLayoutDisplay?.find?.(c => c.name === name)?.checked;
		customSections.forEach(section => {
			if (!projectStatusSectionExpandedMap.has(section.key)) {
				projectStatusSectionExpandedMap.set(section.key, false);
			}
			projectSectionCardHeightMap.set(
				section.key,
				this.calculateHeighestCardV2(
					section.key,
					isChecked('client'),
					isChecked('contact'),
					isChecked('description'),
					this.props.viewer.projects,
					this.props.viewer.projectGroups
				)
			);
			numberOfProjectTilesAfterLastGroupMap.set(section.key, null);
		});
		this.setState(
			{projectStatusSectionExpandedMap, projectSectionCardHeightMap, numberOfProjectTilesAfterLastGroupMap},
			() => this.fetchCalculatedDataIfRequired()
		);
	}

	async fetchCalculatedData(statusOrStageKey) {
		const status = statusOrStageKey;
		const requestBody = isCustomStageKey(status) ? {stageId: status} : {status};
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		if (window.AbortController) {
			//Not supported by IE
			this.abortController = new window.AbortController();
		}
		const signal = this.abortController ? this.abortController.signal : undefined;
		const init = {headers, signal, credentials: 'include', method: 'POST', body: JSON.stringify(requestBody)};

		// Check if we have loaded the data for this status in the last 5 minutes
		const minutesToWait = 5;
		const calculatedFieldsLocalStorageKey = 'projects-page-calculated-data-fetched-status-';
		const calculatedFieldsDataByStatusLocalStorageKey = 'projects-page-calculated-data-map-status-';

		const lastFetchTimeForStatus = Util.localStorageGetItem(calculatedFieldsLocalStorageKey + status);
		if (lastFetchTimeForStatus && Date.now() - +lastFetchTimeForStatus < 1000 * 60 * minutesToWait) {
			const localData = Util.localStorageGetItem(calculatedFieldsDataByStatusLocalStorageKey + status);
			if (localData) {
				const projectDataArray = JSON.parse(localData);
				for (const projectData of projectDataArray) {
					this.calculatedDataMap.set(projectData.id, projectData);
				}
			}
			return;
		}

		// Save before the fetch to avoid multiple calls
		Util.localStorageSetItem(calculatedFieldsLocalStorageKey + status, Date.now());
		return await DirectApi.Fetch_Raw_With_Init('calculated_fields_by_status', init)
			.then(response => response.json())
			.then(projectDataArray => {
				// if fetching project calculated fields threw an error, simply ignore it and return an empty list
				if (!Array.isArray(projectDataArray)) {
					return [];
				}
				for (const projectData of projectDataArray) {
					this.calculatedDataMap.set(projectData.id, projectData);
				}
				Util.localStorageSetItem(
					'projects-page-calculated-data-map',
					JSON.stringify(Array.from(this.calculatedDataMap.entries()))
				);
				Util.localStorageSetItem('projects-page-data-timestamp', Date.now());

				Util.localStorageSetItem(
					calculatedFieldsDataByStatusLocalStorageKey + status,
					JSON.stringify(projectDataArray)
				);
				this.forceUpdate();
				return projectDataArray;
			})
			.catch(error => {
				console.error('Error fetching calculated fields:', error);
			});
	}

	// Memoised on the Relay field, which keeps its reference until a refetch changes it; render reads this
	// several times.
	getCustomFieldDefinitions(props = this.props) {
		if (props !== this.props) return customFieldDefinitionsOf(props);
		const source = this.props.viewer.company.projectListCustomFieldDefinitions;
		if (!this.customFieldDefinitionsCache || this.customFieldDefinitionsCache.source !== source) {
			this.customFieldDefinitionsCache = {source, definitions: customFieldDefinitionsOf(this.props)};
		}
		return this.customFieldDefinitionsCache.definitions;
	}

	// A refetch (e.g. a socket retry) can make a field unavailable mid-session; drop a sort on its column.
	resetUnavailableCustomFieldSort() {
		const shown = visibleCustomFields(this.state.customFieldChoices, this.getCustomFieldDefinitions());
		const sortBy = resolveProjectsSortBy(this.state.sortBy, shown);
		if (sortBy !== this.state.sortBy) {
			resetSavedProjectsSort();
			this.setState({sortBy});
		}
	}

	// What the list's filters can honour right now: its available custom fields, and whether Win Probability
	// is offered.
	getProjectListFilterContext(props = this.props) {
		return {
			customFieldDefinitions: this.getCustomFieldDefinitions(props),
			winProbabilityEnabled: !!props.winProbabilityFilterEnabled,
		};
	}

	// Picker actions on the custom fields section.
	handleCustomFieldChoice(action) {
		const update = applyCustomFieldChoiceAction(
			this.state.customFieldChoices,
			action,
			this.getCustomFieldDefinitions(),
			this.state.sortBy
		);
		writeCustomFieldChoices(update.choices, PROJECTS_CUSTOM_FIELD_SCOPE);
		if (update.sortReset) {
			resetSavedProjectsSort();
		}
		// Re-measure so the native overflow measurements stay current.
		this.setState({customFieldChoices: update.choices, sortBy: update.sortBy}, () => this.resize());
	}

	// The table's width without the custom field columns, so turning them on never changes the Name column.
	nativeTableScrollWidth(element) {
		const customCount =
			this.state.displayMode === 'list'
				? visibleCustomFields(this.state.customFieldChoices, this.getCustomFieldDefinitions()).length
				: 0;
		return element.scrollWidth - customFieldColumnsTableWidthPx(customCount);
	}

	// Temporary solution due to Relay fuckery
	getOverviewProjectConstructorState(props) {
		this.project_statuses = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.RUNNING, PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE];

		const projects = (props.viewer.projects?.edges ?? []).map(edge => edge?.node);
		if (showsOpportunityGroup(Util.hasOpportunityAccess(), projects)) {
			this.project_statuses.unshift(PROJECT_STATUS.OPPORTUNITY);
		}
		const customSections = getCustomStageSections(props);
		this.customStageNames = new Map(customSections.map(section => [section.key, section.name]));
		customSections.forEach(section => this.project_statuses.push(section.key));
		const displayMode = localStorage.getItem('displayMode-projects-overview');
		const hasPriorityLevels = props.viewer.company.priorityLevels
			? props.viewer.company.priorityLevels.edges.length > 0
			: false;

		const localStateColumns = JSON.parse(localStorage.getItem('columns-projects-overview-v3')) || [];
		const localStateCardLayoutDisplay = JSON.parse(localStorage.getItem('projects-overview-card-layout-display')) || [];

		// ascending value as a string
		const ascending = localStorage.getItem('overview-projects-sort-ascending') || 'true';
		// Set initial sort
		const customFieldChoices = readCustomFieldChoices(PROJECTS_CUSTOM_FIELD_SCOPE);
		const shownCustomFields = visibleCustomFields(customFieldChoices, customFieldDefinitionsOf(props));
		// A saved sort on a custom column that is no longer shown falls back to unsorted.
		const savedSortBy = {
			column: localStorage.getItem('overview-projects-sort-column') || null,
			ascending: ascending === 'true',
		};
		const sortBy = resolveProjectsSortBy(savedSortBy, shownCustomFields);
		if (sortBy !== savedSortBy) {
			resetSavedProjectsSort();
		}

		const clientSelected = localStateCardLayoutDisplay.find(c => c.name === 'client')
			? localStateCardLayoutDisplay.find(c => c.name === 'client').checked
			: true;
		const contactSelected = localStateCardLayoutDisplay.find(c => c.name === 'contact')
			? localStateCardLayoutDisplay.find(c => c.name === 'contact').checked
			: false;
		const descriptionSelected = localStateCardLayoutDisplay.find(c => c.name === 'description')
			? localStateCardLayoutDisplay.find(c => c.name === 'description').checked
			: true;
		const cardLayoutDisplay = [
			{
				name: 'id',
				translationId: 'common.id',
				checked: localStateCardLayoutDisplay.find(c => c.name === 'id')
					? localStateCardLayoutDisplay.find(c => c.name === 'id').checked
					: false,
			},
			{
				name: 'status',
				translationId: 'common.status',
				checked: localStateCardLayoutDisplay.find(c => c.name === 'status')
					? localStateCardLayoutDisplay.find(c => c.name === 'status').checked
					: false,
			},
			{
				name: 'dates',
				translationId: 'project_overview.project_dates',
				checked: localStateCardLayoutDisplay.find(c => c.name === 'dates')
					? localStateCardLayoutDisplay.find(c => c.name === 'dates').checked
					: true,
			},
			...(!isFeatureHidden(HIDDEN_FEATURES.CLIENT)
				? [
						{
							name: 'client',
							translationId: 'common.client',
							checked: clientSelected,
						},
				  ]
				: []),
			{
				name: 'contact',
				translationId: 'common.project_owner',
				checked: contactSelected,
			},
			{
				name: 'description',
				translationId: 'common.description',
				checked: descriptionSelected,
			},
		];

		const oldStatusIndex = cardLayoutDisplay.findIndex(col => col.name === 'status');
		const newStatus = {
			name: 'statusV2',
			translationId: 'common.status',
			checked: localStateCardLayoutDisplay.find(c => c.name === 'statusV2')
				? localStateCardLayoutDisplay.find(c => c.name === 'statusV2').checked
				: true,
		};
		cardLayoutDisplay.splice(oldStatusIndex, 1, newStatus);
		const columns = isClientUser()
			? [
					{
						name: 'id',
						translationId: 'common.id',
						checked: true,
					},
					{
						name: 'name',
						translationId: 'common.name',
						checked: true,
					},
					{
						name: 'statusColor',
						translationId: 'common.status',
						checked: localStateColumns.find(column => column.name === 'statusColor')
							? localStateColumns.find(column => column.name === 'statusColor').checked
							: false,
					},
					...(!isFeatureHidden(HIDDEN_FEATURES.CLIENT)
						? [
								{
									name: 'client',
									translationId: 'common.client',
									checked: localStateColumns.find(column => column.name === 'client')
										? localStateColumns.find(column => column.name === 'client').checked
										: true,
								},
						  ]
						: []),
					{
						name: 'contact',
						translationId: 'common.project_owner',
						checked: localStateColumns.find(column => column.name === 'contact')
							? localStateColumns.find(column => column.name === 'contact').checked
							: false,
					},
					{
						name: 'startDate',
						translationId: 'common.project_start',
						checked: localStateColumns.find(column => column.name === 'startDate')
							? localStateColumns.find(column => column.name === 'startDate').checked
							: true,
					},
					{
						name: 'endDate',
						translationId: 'insights.component.list.column.projectDeadline',
						checked: localStateColumns.find(column => column.name === 'endDate')
							? localStateColumns.find(column => column.name === 'endDate').checked
							: true,
					},
			  ]
			: [
					{
						name: 'id',
						translationId: 'common.id',
						checked: true,
					},
					{
						name: 'name',
						translationId: 'common.name',
						checked: true,
					},
					{
						name: 'startDate',
						translationId: 'common.project_start',
						checked: localStateColumns.find(column => column.name === 'startDate')
							? localStateColumns.find(column => column.name === 'startDate').checked
							: true,
					},
					{
						name: 'endDate',
						translationId: 'insights.component.list.column.projectDeadline',
						checked: localStateColumns.find(column => column.name === 'endDate')
							? localStateColumns.find(column => column.name === 'endDate').checked
							: true,
					},
					...(!isFeatureHidden(HIDDEN_FEATURES.CLIENT)
						? [
								{
									name: 'client',
									translationId: 'common.client',
									checked: localStateColumns.find(column => column.name === 'client')
										? localStateColumns.find(column => column.name === 'client').checked
										: true,
								},
						  ]
						: []),
					...(hasPriorityLevels
						? [
								{
									name: 'priorityLevel',
									translationId: 'common.priority',
									checked: localStateColumns.find(column => column.name === 'priorityLevel')
										? localStateColumns.find(column => column.name === 'priorityLevel').checked
										: false,
								},
						  ]
						: []),
					{
						name: 'contact',
						translationId: 'common.project_owner',
						checked: localStateColumns.find(column => column.name === 'contact')
							? localStateColumns.find(column => column.name === 'contact').checked
							: false,
					},
					{
						name: 'completion',
						translationId: 'common.progress',
						checked: localStateColumns.find(column => column.name === 'completion')
							? localStateColumns.find(column => column.name === 'completion').checked
							: true,
					},
					{
						name: 'completionBar',
						translationId: 'common.completion-bar',
						checked: localStateColumns.find(column => column.name === 'completionBar')
							? localStateColumns.find(column => column.name === 'completionBar').checked
							: false,
					},
					{
						name: 'statusColor',
						translationId: 'common.status',
						checked: localStateColumns.find(column => column.name === 'statusColor')
							? localStateColumns.find(column => column.name === 'statusColor').checked
							: false,
					},
					{
						name: 'forecast',
						translationId: 'common.estimated',
						checked: localStateColumns.find(column => column.name === 'forecast')
							? localStateColumns.find(column => column.name === 'forecast').checked
							: false,
					},
					{
						name: 'reported',
						translationId: 'common.actual_hours',
						checked: localStateColumns.find(column => column.name === 'reported')
							? localStateColumns.find(column => column.name === 'reported').checked
							: false,
					},
					{
						name: 'remaining',
						translationId: 'common.remaining_work',
						checked: localStateColumns.find(column => column.name === 'remaining')
							? localStateColumns.find(column => column.name === 'remaining').checked
							: true,
					},
					{
						name: 'variance_to_forecast',
						translationId: 'common.estimated_minus_projected_total',
						checked: localStateColumns.find(column => column.name === 'variance_to_forecast')
							? localStateColumns.find(column => column.name === 'variance_to_forecast').checked
							: false,
					},
					{
						name: 'tasksCount',
						translationId: 'common.cards-total',
						checked: localStateColumns.find(column => column.name === 'tasksCount')
							? localStateColumns.find(column => column.name === 'tasksCount').checked
							: false,
					},
					{
						name: 'doneTasksCount',
						translationId: 'common.cards-done',
						checked: localStateColumns.find(column => column.name === 'doneTasksCount')
							? localStateColumns.find(column => column.name === 'doneTasksCount').checked
							: false,
					},
					{
						name: 'labels',
						translationId: 'common.labels',
						checked: localStateColumns.find(column => column.name === 'labels')
							? localStateColumns.find(column => column.name === 'labels').checked
							: false,
					},
					{
						name: 'projectPersonsCount',
						translationId: 'common.team-size',
						checked: localStateColumns.find(column => column.name === 'projectPersonsCount')
							? localStateColumns.find(column => column.name === 'projectPersonsCount').checked
							: false,
					},
			  ];

		const oldStatusColorIndex = columns.findIndex(col => col.name === 'statusColor');
		const newStatusColor = {
			name: 'statusColorV2',
			translationId: 'common.status',
			checked: localStateColumns.find(c => c.name === 'statusColorV2')
				? localStateColumns.find(c => c.name === 'statusColorV2').checked
				: true,
		};
		columns.splice(oldStatusColorIndex, 1, newStatusColor);
		const financialColumns = [
			{
				name: 'win-chance',
				translationId: 'project.win_chance',
				checked: localStateColumns.find(column => column.name === 'win-chance')
					? localStateColumns.find(column => column.name === 'win-chance').checked
					: false,
			},
		];

		if (CompanySetupUtil.hasFinance() && !isClientUser()) {
			const pushAtIndex = columns.findIndex(col => col.name === 'doneTasksCount');
			columns.splice(pushAtIndex + 1, 0, ...financialColumns);
		}

		this.NUMERIC_COLUMNS = [
			'win-chance',
			'forecast',
			'reported',
			'remaining',
			'tasksCount',
			'doneTasksCount',
			'projectPersonsCount',
			'variance_to_forecast',
		];
		const projectStatusSectionExpandedMap = localStorage.getItem('projects-page-section-expanded-map')
				? new Map(JSON.parse(localStorage.getItem('projects-page-section-expanded-map')))
				: new Map(),
			projectSectionCardHeightMap = new Map(),
			numberOfProjectTilesAfterLastGroupMap = new Map();

		this.project_statuses.forEach(project_status => {
			if (!projectStatusSectionExpandedMap.has(project_status)) {
				projectStatusSectionExpandedMap.set(project_status, project_status === PROJECT_STATUS.RUNNING);
			}
			const height = this.calculateHeighestCardV2(
				project_status,
				clientSelected,
				contactSelected,
				descriptionSelected,
				props.viewer.projects,
				props.viewer.projectGroups
			);
			projectSectionCardHeightMap.set(project_status, height);
			numberOfProjectTilesAfterLastGroupMap.set(project_status, null);
		});

		const localStorageTimestamp = localStorage.getItem('projects-page-data-timestamp');

		this.calculatedDataMap =
			localStorage.getItem('projects-page-calculated-data-map') &&
			localStorageTimestamp &&
			Date.now() - +localStorageTimestamp < 1000 * 60 * 60
				? new Map(JSON.parse(localStorage.getItem('projects-page-calculated-data-map')))
				: new Map();

		let filters;
		const filtersKey = 'overview-projects-filters-v4';
		if (localStorage.getItem(`${filtersKey}`)) {
			filters = JSON.parse(localStorage.getItem(`${filtersKey}`));
		} else {
			filters = {
				project: {},
			};
		}
		const filterFunctions = buildProjectListFilterFunctions(filters, this.getProjectListFilterContext(props));
		// Return state object
		return {
			searchFilterValue: '',
			sortBy,
			displayMode: displayMode || 'list',
			listOverflowWidth: null,
			nameOverflowPercentage: null,
			labelFilterValue: (JSON.parse(localStorage.getItem('overview-projects-filter-value-label')) || []).filter(
				val => val !== null
			),
			clientFilterValue: (JSON.parse(localStorage.getItem('overview-projects-filter-value-client')) || []).filter(
				val => val !== null
			),
			statusFilterValue: (JSON.parse(localStorage.getItem('overview-projects-filter-value-status')) || []).filter(
				val => val !== null
			),
			rateCardFilterValue: (JSON.parse(localStorage.getItem('overview-projects-filter-value-rateCard')) || []).filter(
				val => val !== null
			),
			contactFilterValue: (JSON.parse(localStorage.getItem('overview-projects-filter-value-contact')) || []).filter(
				val => val !== null
			),
			columns: columns,
			customFieldChoices,
			cardLayoutDisplay,
			projectStatusSectionExpandedMap,
			projectStatusFinancialDataFetchedMap: new Map(),
			projectStatusCalculatedDataFetchedMap: new Map(),
			projectSectionCardHeightMap,
			numberOfProjectTilesAfterLastGroupMap,
			filters,
			filterFunctions,
			lazyDataFetched: !this.props.excludeDoneOrHalted,
		};
	}

	overviewProjectDidMount(props) {
		const {numberOfProjectTilesAfterLastGroupMap} = this.state;
		this.project_statuses.forEach(project_status => {
			const numberOfProjects = this.getNumberOfExtraMarginProjects(project_status);
			numberOfProjectTilesAfterLastGroupMap.set(project_status, numberOfProjects);
		});
		this.setState({numberOfProjectTilesAfterLastGroupMap});

		const socketEvents = [
			{
				type: SOCKET_EVENT_TYPE.PROJECT,
				action: SOCKET_ACTION.CREATE,
				personIds: !hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) ? props.viewer.backendId : 'ALL',
			},
			{
				type: SOCKET_EVENT_TYPE.PROJECT,
				action: SOCKET_ACTION.DELETE,
				personIds: !hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) ? props.viewer.backendId : 'ALL',
			},
		];
		if (!hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL)) {
			socketEvents.push({
				type: SOCKET_EVENT_TYPE.PROJECT_PERSON,
				action: SOCKET_ACTION.CREATE,
				personIds: props.viewer.backendId,
			});
			socketEvents.push({
				type: SOCKET_EVENT_TYPE.PROJECT_PERSON,
				action: SOCKET_ACTION.DELETE,
				personIds: props.viewer.backendId,
			});
		}

		props.setSocketConfig(socketEvents, this.props.relay.refetch);
		let columns;
		if (this.state.displayMode === 'list') {
			columns = this.state.columns
				.filter(column => column.checked)
				.map(column => {
					return {name: column.name, checked: column.checked};
				});
		} else {
			columns = this.state.cardLayoutDisplay
				.filter(column => column.checked)
				.map(column => {
					return {name: column.name, checked: column.checked};
				});
		}

		tracking.trackPage('projects', null, columns, {display: this.state.displayMode});
		this.resize();
		window.addEventListener('resize', this.resize);

		this.fetchCalculatedDataIfRequired();
	}

	fetchCalculatedDataIfRequired() {
		const {projectStatusSectionExpandedMap, projectStatusCalculatedDataFetchedMap} = this.state;

		for (const status of this.project_statuses) {
			if (projectStatusSectionExpandedMap.get(status) && !projectStatusCalculatedDataFetchedMap.has(status)) {
				this.fetchCalculatedData(status);
				projectStatusCalculatedDataFetchedMap.set(status, true);
			}
		}
	}

	getNumberOfExtraMarginProjects(project_status) {
		//needed in v2. Calculate amount of projects that need extra margin on top
		if (this['last_project_group_item_' + project_status] && this.scrollable) {
			const filledWidth =
				this['last_project_group_item_' + project_status].getBoundingClientRect().x -
				66 +
				this['last_project_group_item_' + project_status].getBoundingClientRect().width +
				16;
			//add 17px (66 left margin - 49 right margin) to take margin on both sides into account
			const totalWidth = this.scrollable.getBoundingClientRect().width - 115;
			const availableWidth = totalWidth - filledWidth;
			return Math.floor(availableWidth / 265);
		}
		return null;
	}

	calculateHeighestCardV2(project_status, clientSelected, contactSelected, descriptionSelected, projects, projectGroups) {
		let projectNameHeightMax = 0,
			descriptionHeightMax = 0,
			projectClientHeightMax = 0,
			projectContactHeightMax = 0;
		// find longest project name and calculate how many lines it will take. Needed in new UI to calc additional height card needs.
		const calcProjectHeight = project => {
			const projectName = project.node.name ? project.node.name : '';
			//if there are no white spaces name will be only in one line so no additional height needed
			const projectNameLines = projectName.includes(' ') ? Math.ceil((9 * projectName.length) / 201) : 0;
			const projectNameHeight = projectNameLines > 1 ? 20 : 0;
			const descriptionHeight = descriptionSelected ? (project.node.description ? 85 : 48) : 0;
			const projectClientheight = clientSelected && project.node.client ? 26 : 0;
			const projectContactHeight =
				contactSelected && project.node.projectPersons
					? project.node.projectPersons.edges.filter(pp => pp.node.isContactPerson).length !== 0
						? 59
						: 48
					: 0;
			projectNameHeightMax = projectNameHeight > projectNameHeightMax ? projectNameHeight : projectNameHeightMax;
			descriptionHeightMax = descriptionHeight > descriptionHeightMax ? descriptionHeight : descriptionHeightMax;
			projectClientHeightMax =
				projectClientheight > projectClientHeightMax ? projectClientheight : projectClientHeightMax;
			projectContactHeightMax =
				projectContactHeight > projectContactHeightMax ? projectContactHeight : projectContactHeightMax;
			return 146 + projectNameHeight + descriptionHeight + projectClientheight + projectContactHeight;
		};
		let height = 0;
		projects.edges
			.filter(project => stageGroupKeyOf(project.node) === project_status)
			.forEach(project => {
				const projectHeight = calcProjectHeight(project);
				if (height < projectHeight) {
					height = projectHeight;
				}
			});
		projectGroups.edges.forEach(pg => {
			pg.node.projects.edges
				.filter(project => stageGroupKeyOf(project.node) === project_status)
				.forEach(project => {
					const projectHeight = calcProjectHeight(project);
					if (height < projectHeight) {
						height = projectHeight;
					}
				});
		});
		return {
			heightTotal: Math.floor(height),
			projectNameHeightMax,
			descriptionHeightMax,
			projectClientHeightMax,
			projectContactHeightMax,
		};
	}

	resize() {
		const {numberOfProjectTilesAfterLastGroupMap} = this.state;
		this.project_statuses.forEach(project_status => {
			const numberOfProjects = this.getNumberOfExtraMarginProjects(project_status);
			numberOfProjectTilesAfterLastGroupMap.set(project_status, numberOfProjects);
		});
		this.requestedFrame = null;
		const element = this.table;
		if (element === null || element === undefined) {
			this.setState({numberOfProjectTilesAfterLastGroupMap});
			return;
		}

		if (this.state.listOverflowWidth === null) {
			const nativeScrollWidth = this.nativeTableScrollWidth(element);
			if (nativeScrollWidth > element.parentElement.clientWidth) {
				this.setState({
					listOverflowWidth: nativeScrollWidth,
					nameOverflowPercentage: this.nameHeader
						? Math.floor((this.nameHeader.clientWidth / nativeScrollWidth) * 100)
						: 0,
					numberOfProjectTilesAfterLastGroupMap,
					shouldRecalculateCompletionBarWidth: true,
				});
			}
		} else {
			if (this.state.listOverflowWidth <= element.parentElement.clientWidth) {
				this.setState({
					listOverflowWidth: null,
					nameOverflowPercentage: null,
					numberOfProjectTilesAfterLastGroupMap,
					shouldRecalculateCompletionBarWidth: true,
				});
			} else {
				this.setState({numberOfProjectTilesAfterLastGroupMap, shouldRecalculateCompletionBarWidth: true});
			}
		}
	}

	resetShouldRecalculateCompletionBarWidth() {
		if (this.state.shouldRecalculateCompletionBarWidth) {
			this.setState({shouldRecalculateCompletionBarWidth: false});
		}
	}

	handleShortcutProjects(e) {
		if (e.altKey && e.shiftKey && e.keyCode === 88) {
			this.clearFilters();
		}
	}

	handleColumnsFilter(selected, parentOption) {
		const customFieldAction =
			this.state.displayMode === 'list'
				? customFieldEyeAction(selected, parentOption, this.getCustomFieldDefinitions())
				: null;
		if (customFieldAction) {
			this.handleCustomFieldChoice(customFieldAction);
			return;
		}
		const allSelected = [
			selected.name,
			...(selected.nestedOptions
				? selected.nestedOptions.flatMap(c => [c.name, ...(c.nestedOptions ? c.nestedOptions.map(gc => gc.name) : [])])
				: []),
		];
		if (this.state.displayMode === 'list') {
			const columns = this.state.columns.map(col => {
				if (allSelected.includes(col.name)) {
					return {
						name: col.name,
						checked: !selected.checked,
						translationId: col.translationId,
						xero: col.xero,
					};
				} else {
					return {
						name: col.name,
						checked: col.checked,
						translationId: col.translationId,
						xero: col.xero,
					};
				}
			});

			Util.localStorageSetItem('columns-projects-overview-v3', JSON.stringify(columns));
			this.setState({columns: columns}, () => {
				this.fetchCalculatedDataIfRequired();
			});
		} else {
			let contactSelected, clientSelected, descriptionSelected;
			const cardLayoutDisplay = this.state.cardLayoutDisplay.map(el => {
				const obj =
					el.name === selected.name
						? {
								name: el.name,
								translationId: el.translationId,
								checked: !selected.checked,
						  }
						: {name: el.name, translationId: el.translationId, checked: el.checked};
				if (obj.name === 'contact') {
					contactSelected = obj.checked;
				} else if (obj.name === 'client') {
					clientSelected = obj.checked;
				} else if (obj.name === 'description') {
					descriptionSelected = obj.checked;
				}
				return obj;
			});
			Util.localStorageSetItem('projects-overview-card-layout-display', JSON.stringify(cardLayoutDisplay));
			const {projectSectionCardHeightMap} = this.state;
			this.project_statuses.forEach(project_status => {
				const projectSectionCardHeight = this.calculateHeighestCardV2(
					project_status,
					clientSelected,
					contactSelected,
					descriptionSelected,
					this.props.viewer.projects,
					this.props.viewer.projectGroups
				);
				projectSectionCardHeightMap.set(project_status, projectSectionCardHeight);
			});
			this.setState({cardLayoutDisplay, projectSectionCardHeightMap});
		}
	}

	handleFilterChange(filterType, value) {
		this.setState({[filterType + 'FilterValue']: value, filterChanged: true});
		Util.localStorageSetItem('overview-projects-filter-value-' + filterType, JSON.stringify(value));
	}

	clearFilters() {
		this.setState({
			searchFilterValue: '',
			labelFilterValue: [],
			clientFilterValue: [],
			statusFilterValue: [],
			rateCardFilterValue: [],
			contactFilterValue: [],
		});
		localStorage.removeItem('overview-projects-filter-value-label');
		localStorage.removeItem('overview-projects-filter-value-client');
		localStorage.removeItem('overview-projects-filter-value-status');
		localStorage.removeItem('overview-projects-filter-value-rateCard');
		localStorage.removeItem('overview-projects-filter-value-contact');
	}

	getClearFilterText() {
		const {formatMessage} = this.props.intl;
		if (
			this.state.labelFilterValue.length ||
			this.state.clientFilterValue.length ||
			this.state.statusFilterValue.length ||
			this.state.rateCardFilterValue.length ||
			this.state.contactFilterValue.length
		) {
			if (this.state.searchFilterValue.trim().length) {
				return formatMessage({id: 'common.clear-all'});
			} else {
				return formatMessage({id: 'common.clear-filters'});
			}
		}
		if (this.state.searchFilterValue.trim().length) {
			return formatMessage({id: 'common.clear-search'});
		}
		return '';
	}

	setDisplayMode(value) {
		Util.localStorageSetItem('displayMode-projects-overview', value);
		tracking.trackPageAction('Display changed', {display: value});
		trackEvent('Display Mode', 'Changed', {display: value});

		this.setState({displayMode: value}, () => {
			this.fetchCalculatedDataIfRequired();
		});
	}

	handleSearchChange(e) {
		this.setState({searchFilterValue: e});
	}

	handleAddProjectFromEmptyState() {
		showModal({
			type: MODAL_TYPE.NEW_PROJECT_V2,
		});
	}

	setSortBy(column) {
		let ascending = true;
		if (column === this.state.sortBy.column) {
			ascending = !this.state.sortBy.ascending;
		}
		Util.localStorageSetItem('overview-projects-sort-column', column);
		Util.localStorageSetItem('overview-projects-sort-ascending', ascending);
		this.setState({sortBy: {column: column, ascending: ascending}});
	}

	getGroupHTML(
		project_status,
		group,
		nameStyle,
		projectNameColumnWidth,
		hasFinancialAccess,
		shownCustomFields,
		customFieldFormat
	) {
		const rows = [];
		group.node.projects.edges
			.filter(project => project.node.showProject && stageGroupKeyOf(project.node) === project_status)
			.forEach(project => {
				const lineItem = (
					<ProjectListProjectLineItem
						project={project}
						key={project.node.id}
						nameStyle={nameStyle}
						columns={this.state.columns}
						xeroEnabled={this.props.viewer.company.xeroEnabled}
						isInProjectGroup={true}
						selectedMenuItem={this.state.selectedMenuItem}
						searchFilterValue={this.state.searchFilterValue}
						filterChanged={this.state.filterChanged}
						projectNameColumnWidth={projectNameColumnWidth}
						calculatedDataMap={new Map(this.calculatedDataMap)}
						shouldRecalculateCompletionBarWidth={this.state.shouldRecalculateCompletionBarWidth}
						resetShouldRecalculateCompletionBarWidth={this.resetShouldRecalculateCompletionBarWidth.bind(this)}
						hasFinancialAccess={hasFinancialAccess}
						customFieldColumns={shownCustomFields}
						customFieldFormat={customFieldFormat}
					/>
				);
				rows.push(
					<ReactVisibilitySensor partialVisibility={true} key={project.node.id} offset={{top: -200, bottom: -200}}>
						{({isVisible}) => {
							return isVisible ? lineItem : <tr style={{height: '40px'}} />;
						}}
					</ReactVisibilitySensor>
				);
			});
		if (rows.length !== 0) {
			const groupLineItem = (
				<ProjectListConnectedProjectLineItem
					key={group.node.id}
					projectGroup={group}
					projectGroupCompletion={group.node.completion}
					groupCompanyId={group.node.companyProjectGroupId}
					columns={this.state.columns}
					hasXeroEnabled={this.props.viewer.company.xeroEnabled}
					selectedMenuItem={this.state.selectedMenuItem}
					searchFilterValue={this.state.searchFilterValue}
					filterChanged={this.state.filterChanged}
					projectNameColumnWidth={projectNameColumnWidth}
					calculatedDataMap={new Map(this.calculatedDataMap)}
					shouldRecalculateCompletionBarWidth={this.state.shouldRecalculateCompletionBarWidth}
					resetShouldRecalculateCompletionBarWidth={this.resetShouldRecalculateCompletionBarWidth.bind(this)}
					hasFinancialAccess={hasFinancialAccess}
					customFieldColumns={shownCustomFields}
					customFieldFormat={customFieldFormat}
				/>
			);
			rows.unshift(
				<ReactVisibilitySensor partialVisibility={true} key={group.node.id} offset={{top: -200, bottom: -200}}>
					{({isVisible}) => {
						return isVisible ? groupLineItem : <tr style={{height: '40px'}} />;
					}}
				</ReactVisibilitySensor>
			);
		}
		return rows;
	}

	onFilterChange(filters) {
		this.setState({filters, filterFunctions: buildProjectListFilterFunctions(filters, this.getProjectListFilterContext())});
	}

	groupEyeOptions(options) {
		const projectBasicsOptions = options.filter(option =>
			[
				'client',
				'contact',
				'statusColor',
				'statusColorV2',
				'priorityLevel',
				'projectPersonsCount',
				'win-chance',
			].includes(option.name)
		);
		const datesOptions = options.filter(option => ['startDate', 'endDate'].includes(option.name));
		const scopeOptions = options.filter(option =>
			['completion', 'forecast', 'remaining', 'variance_to_forecast', 'reported'].includes(option.name)
		);
		const timeRegOptions = options.filter(option => ['reported'].includes(option.name));
		const tasksOptions = options.filter(option => ['tasksCount', 'doneTasksCount'].includes(option.name));
		const sageSyncTimeRegsFromIntacct = SageUtil.syncTimeRegsFromIntacct(this.props.viewer.company);
		const showTimeRegistrations = sageSyncTimeRegsFromIntacct;

		const nestedOptions = [
			{
				name: 'projectBasics',
				disabled: false,
				checked: projectBasicsOptions.some(option => option.checked),
				translationId: 'common.project_basics',
				nestedOptions: projectBasicsOptions,
			},
			{
				name: 'dates',
				disabled: false,
				checked: datesOptions.some(option => option.checked),
				translationId: 'project_overview.project_dates',
				nestedOptions: datesOptions,
			},
			{
				name: 'scope',
				disabled: false,
				checked: scopeOptions.some(option => option.checked),
				translationId: 'common.hours_and_points',
				nestedOptions: scopeOptions,
			},
			...(showTimeRegistrations
				? [
						{
							name: 'timeRegistrations',
							disabled: false,
							checked: timeRegOptions.some(option => option.checked),
							translationId: 'common.time_registrations',
							nestedOptions: timeRegOptions,
						},
				  ]
				: []),
			{
				name: 'tasks',
				disabled: false,
				checked: tasksOptions.some(option => option.checked),
				translationId: 'common.tasks',
				nestedOptions: tasksOptions,
			},

			options.find(option => option.name === 'labels'),
		].filter(option => option && (!option.nestedOptions || (option.nestedOptions && option.nestedOptions.length > 0)));
		remapOptionTranslationIds(nestedOptions);
		const customFieldGroup = customFieldEyeGroup(this.getCustomFieldDefinitions(), this.state.customFieldChoices);
		return customFieldGroup ? [...nestedOptions, customFieldGroup] : nestedOptions;
	}

	getHeaderTitle() {
		return (
			<TopHeaderBarWrapper sidePadding={66}>
				<TopHeaderBar title={this.props.intl.formatMessage({id: 'common.all_projects'})} content={[]} />
			</TopHeaderBarWrapper>
		);
	}

	getHeader(columnOptions) {
		const leftContent = [],
			rightContent = [];
		const columnsFiltered = columnOptions.filter(col => col.name !== 'completionBar');
		const hasPriorityLevels = this.props.viewer.company.priorityLevels
			? this.props.viewer.company.priorityLevels.edges.length > 0
			: false;

		// The Custom Fields group is in the list view's options only (groupEyeOptions). With custom field columns
		// the table can scroll sideways, which must not close the picker.
		leftContent.push({
			type: ELEMENT_TYPE.THE_EYE,
			openRight: true,
			options: this.state.displayMode === 'list' ? this.groupEyeOptions(columnsFiltered) : this.state.cardLayoutDisplay,
			onSelect: this.handleColumnsFilter.bind(this),
			keepOpenOnUnrelatedScroll: this.state.displayMode === 'list' && this.getCustomFieldDefinitions().length > 0,
		});

		leftContent.push({
			type: ELEMENT_TYPE.VIEW_TYPE_BUTTON,
			callback: this.setDisplayModeV2.bind(this),
			currentView: this.state.displayMode === 'cards' ? 'list' : 'grid',
		});

		rightContent.push({
			type: ELEMENT_TYPE.SEARCH_LAZY,
			value: this.state.searchFilterValue,
			onChange: this.handleSearchChange.bind(this),
		});
		if (!this.props.viewer.client) {
			// INTERNAL TIME

			const projectFilters = [/*FILTER_TYPE.PERSON,*/ /*FILTER_TYPE.PROJECT, */ FILTER_TYPE.PROJECT_STAGE];
			const hasClientContactFilter = isClientContactsFeatureEnabled();
			const projectAdvancedFilters = [
				FILTER_TYPE.DEADLINE,
				FILTER_TYPE.CLIENT,
				...(hasClientContactFilter ? [FILTER_TYPE.CLIENT_CONTACT] : []),
				FILTER_TYPE.CONTACT,
				FILTER_TYPE.LABEL,
				FILTER_TYPE.PROGRESS,
				...(hasPriorityLevels ? [FILTER_TYPE.PRIORITY_LEVEL] : []),
				FILTER_TYPE.PROJECT_STATUS,
			];

			if (
				CompanySetupUtil.hasFinance() &&
				!isFeatureHidden(HIDDEN_FEATURES.REVENUE) &&
				hasSomePermission([
					PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION,
					PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE,
				])
			) {
				projectAdvancedFilters.push(FILTER_TYPE.PROJECT_TYPE);
				projectAdvancedFilters.push(FILTER_TYPE.RATE_CARD);
			}

			const winProbabilityEnabled = !!this.props.winProbabilityFilterEnabled;
			if (winProbabilityEnabled) {
				projectAdvancedFilters.push(FILTER_TYPE.OPPORTUNITY_WIN_PROBABILITY);
			}

			const taskFilters = [];
			const peopleFilters = [];
			rightContent.push({
				type: ELEMENT_TYPE.FILTER_V4,
				defaultSection: FILTER_SECTIONS.PROJECTS,
				projectFilters: getOrderedFilters(projectFilters, projectAdvancedFilters, this.props.intl.formatMessage),
				peopleFilters,
				taskFilters,
				primaryFilters: {
					[FILTER_SECTIONS.PROJECTS]: [
						FILTER_TYPE.CLIENT,
						FILTER_TYPE.CONTACT,
						FILTER_TYPE.LABEL,
						FILTER_TYPE.PROJECT_TYPE,
						FILTER_TYPE.PROJECT_STAGE,
						FILTER_TYPE.RATE_CARD,
					],
				},
				customFieldFilterDefinitions: this.getCustomFieldDefinitions(),
				customFieldFiltersUnderMoreOptions: true,
				unavailableFilterTypes: winProbabilityEnabled ? [] : [FILTER_TYPE.OPPORTUNITY_WIN_PROBABILITY],
				// Win Probability on this list offers the fixed default ranges, never the account's stages.
				opportunityStageBands: DEFAULT_STAGE_BAND_CONNECTION,
				viewer: this.props.viewer,
				filterSection: FILTER_SECTION.PROJECTS_OVERVIEW,
				appliedFiltersName: 'overview-projects-filters-v4',
				onFiltersChange: this.onFilterChange.bind(this),
				noMenu: true,
				cy: 'project-list-filter',
			});
		}

		if (hasPermission(PERMISSION_TYPE.PROJECTS_CREATE) && !hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
			rightContent.push({
				type: ELEMENT_TYPE.BUTTON,
				text: this.props.intl.formatMessage({id: 'new_project.title'}),
				userpilot: 'new-project-button',
				callback: this.handleCreateProject.bind(this),
				style: BUTTON_STYLE.OUTLINE,
				color: BUTTON_COLOR.PURPLE,
			});
		}

		return (
			<HeaderBar
				innerRef={div => (this.header_bar = div)}
				parentGroup={null}
				leftContent={leftContent}
				rightContent={rightContent}
			/>
		);
	}

	setDisplayModeV2() {
		this.setDisplayMode(this.state.displayMode === 'cards' ? 'list' : 'cards');
	}

	handleCreateProject() {
		const rawId = this.props.viewer && this.props.viewer.backendId;
		const personId = rawId != null ? Number(rawId) || undefined : undefined;
		// AiProjectPlanningModal is the redesigned project-creation modal (TNSR-635), behind its own
		// project_create_modal_redesign flag — off by default. Once on, the forecast_agent_planning
		// flag/MANAGE_ACCOUNT_SETTINGS/AI_ACCESS gate lives inside the new modal (aiEnabled prop in
		// generic_modal_conductor.js), controlling only the SoW promo.
		//
		// Off: full parity with pre-TNSR-635 production, restoring the original routing through
		// ProjectCreationChoiceModal (Manual vs SoW) for anyone who already had forecast_agent_planning
		// — everyone else goes straight to NewProjectModalV2, same as before this PR ever shipped.
		if (hasFeatureFlag(FEATURE_FLAGS.PROJECT_CREATE_MODAL_REDESIGN)) {
			showModal({type: MODAL_TYPE.AI_PROJECT_PLANNING, personId, entryPoint: BASELINE_BUILDER_ENTRY_POINT.PROJECT_LIST});
		} else if (
			hasFeatureFlag('forecast_agent_planning') &&
			hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS) &&
			hasAiAccess()
		) {
			showModal({
				type: MODAL_TYPE.PROJECT_CREATION_CHOICE,
				personId,
				entryPoint: BASELINE_BUILDER_ENTRY_POINT.PROJECT_LIST,
			});
		} else {
			showModal({type: MODAL_TYPE.NEW_PROJECT_V2});
		}
	}

	getProjectGroupHTML(project_status, projectGroup, groupIndex, isLastItem) {
		const lastViewedPage = localStorage.getItem('project-group-section-last-viewed') || 'workflow';
		const path = '/connected/X-' + projectGroup.node.companyProjectGroupId + '/' + lastViewedPage;
		const projectsToShow = projectGroup.node.projects.edges
			.filter(project => project.node.showProject && project_status === stageGroupKeyOf(project.node))
			.sort((a, b) => {
				if (a.node.companyProjectId < b.node.companyProjectId) return -1;
				return 1;
			});
		const textColor = util.getTextColorV2(projectGroup.node.color);
		return (
			<div
				className="project-group-v2"
				key={groupIndex}
				ref={isLastItem ? el => (this['last_project_group_item_' + project_status] = el) : null}
			>
				<Link to={path}>
					<div
						className={
							'project-group-header' +
							(projectGroup.node.color === '#ffffff' ? ' add-border' : ' only-bottom-border')
						}
						style={{backgroundColor: projectGroup.node.color, color: textColor}}
					>
						<div className={'icon' + (textColor === '#ffffff' ? ' white' : '')} />
						<span className="project-group-id">{`X${projectGroup.node.companyProjectGroupId}`}</span>
						<span className="project-group-name">{projectGroup.node.name}</span>
					</div>
				</Link>
				<div className="connected-projects-container">
					{projectsToShow.map((project, index) => (
						<ProjectListProjectCard
							key={index}
							projectCardHeight={this.state.projectSectionCardHeightMap.get(project_status)}
							cardLayoutDisplay={this.state.cardLayoutDisplay}
							project={project}
							index={index}
							hasTimeApproval={this.hasTimeApproval}
							calculatedDataMap={this.calculatedDataMap}
						/>
					))}
				</div>
			</div>
		);
	}

	toggleProjectStatusSection(project_status) {
		const projectStatusSectionExpandedMap = new Map(this.state.projectStatusSectionExpandedMap);
		this.project_statuses.forEach(status => {
			const setStatus =
				status === project_status ? !this.state.projectStatusSectionExpandedMap.get(project_status) : false;
			projectStatusSectionExpandedMap.set(status, setStatus);
		});

		const stateObject = {projectStatusSectionExpandedMap};
		if (!this.state.projectStatusSectionExpandedMap.get(project_status)) {
			stateObject.loadingSection = true;
		}
		Util.localStorageSetItem(
			'projects-page-section-expanded-map',
			JSON.stringify(Array.from(projectStatusSectionExpandedMap.entries()))
		);
		this.setState(stateObject, () => {
			this.fetchCalculatedDataIfRequired();
		});
	}

	hasAnyProjectsInProjectStatusSection(projectGroup, project_status) {
		const connectedProjectsStatuses = projectGroup.node.projects.edges
			.filter(p => p.node.showProject)
			.map(p => stageGroupKeyOf(p.node));
		return connectedProjectsStatuses.includes(project_status);
	}

	isStatusSectionReady(project_status, lazyDataFetched) {
		const needsLazyData =
			project_status === PROJECT_STATUS.HALTED ||
			project_status === PROJECT_STATUS.DONE ||
			isCustomStageKey(project_status);
		if (needsLazyData && !lazyDataFetched) {
			return false;
		}
		return true;
	}

	getSectionTitle(project_status) {
		if (!isCustomStageKey(project_status)) {
			return profileSectionLabel(project_status, this.props.intl);
		}
		const cached = getProjectStages().find(stage => stage.id === project_status);
		return stageLabel(cached ?? {name: this.customStageNames?.get(project_status)}, this.props.intl);
	}

	getProjectStatusSectionCount(projects, project_status, lazyDataFetched) {
		if (!this.isStatusSectionReady(project_status, lazyDataFetched)) {
			return '-';
		}
		let count = 0;
		projects.forEach(p => {
			if (p.node.projects) {
				const connectedProjectsLength = p.node.projects.edges.filter(
					nestedProject => nestedProject.node.showProject && stageGroupKeyOf(nestedProject.node) === project_status
				).length;
				count += connectedProjectsLength;
			} else {
				if ((this.props.viewer.client || !p.node.isInProjectGroup) && stageGroupKeyOf(p.node) === project_status) {
					++count;
				}
			}
		});
		return count;
	}

	getColumnWidth(columnName) {
		switch (columnName) {
			case 'id':
				return '60px';
			case 'completion':
			case 'forecast':
			case 'reported':
			case 'remaining':
			case 'tasksCount':
			case 'doneTasksCount':
				return '100px';
			case 'client':
				return '140px';
			case 'statusColor':
			case 'statusColorV2':
				return '50px';
			case 'labels':
				return '105px';
			case 'startDate':
			case 'endDate':
				return '110px';
			case 'contact':
				return '100px';
			case 'projectPersonsCount':
				return '70px';
			default:
				return '85px';
		}
	}

	render() {
		if (!this.props.viewer.company) return <div />;
		const {formatMessage} = this.props.intl;
		const hasFinancialAccess = hasSomePermission([
			PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION,
			PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE,
		]);
		const canAddProjects = hasPermission(PERMISSION_TYPE.PROJECTS_CREATE);

		//add projects to list start
		let projects = [];
		this.props.viewer.projectGroups.edges.forEach(pGroup => {
			projects.push(cloneDeep(pGroup));
		});
		this.props.viewer.projects.edges
			.filter(p => this.props.viewer.client || !p.node.isInProjectGroup)
			.forEach(p => projects.push(p));
		//add projects to list end

		projects = filterProjects(
			projects,
			this.state.searchFilterValue,
			this.state.filters,
			this.state.filterFunctions,
			this.calculatedDataMap
		);

		//empty state message start
		const hasActiveFilters =
			this.state.statusFilterValue.length ||
			this.state.clientFilterValue.length ||
			this.state.rateCardFilterValue.length ||
			this.state.labelFilterValue.length;
		let infoMessageId;
		if (this.state.searchFilterValue !== '') {
			infoMessageId = 'empty_state_projects.no-match';
		} else if (
			hasActiveFilters ||
			(this.state.filters && this.state.filters.project && Object.keys(this.state.filters.project).length > 0)
		) {
			infoMessageId = 'empty_state_projects.filters_no_match';
		} else {
			if (hasPermission(PERMISSION_TYPE.PROJECTS_CREATE)) {
				infoMessageId = 'empty_state_projects.title-manager';
			} else {
				infoMessageId = 'empty_state_projects.title-member';
			}
		}
		//empty state message end

		const columns = this.state.columns.filter(
			col => col.name !== 'id' && (col.name !== 'win-chance' || hasFinancialAccess)
		);

		const shownCustomFields =
			this.state.displayMode === 'list'
				? visibleCustomFields(this.state.customFieldChoices, this.getCustomFieldDefinitions())
				: [];
		const customFieldFormat = {
			locale: this.props.intl.locale,
			decimalSeparator: decimalSeparatorFor(this.props.viewer.language),
		};

		let nameStyle = {};
		if (this.state.listOverflowWidth !== null) {
			// In px while custom columns show: the percentage was taken against the native table width, and would
			// otherwise apply to the wider table.
			const nameWidth = shownCustomFields.length
				? Math.floor((this.state.listOverflowWidth * this.state.nameOverflowPercentage) / 100) + 'px'
				: this.state.nameOverflowPercentage + '%';
			nameStyle = {width: nameWidth, maxWidth: '150px', minWidth: '80px'};
		}
		const overflowingList =
			this.state.displayMode === 'list' &&
			this.table &&
			this.table.getBoundingClientRect().width > window.innerWidth - 66;
		const activeColNumber = this.state.columns.filter(
			col =>
				col.name !== 'name' &&
				col.name !== 'id' &&
				col.name !== 'completionBar' &&
				(this.props.viewer.company.xeroEnabled || !col.name.includes('xero')) &&
				col.checked
		).length;
		const projectNameColumnWidth =
			this.state.displayMode === 'list'
				? this.scrollable
					? (this.scrollable.getBoundingClientRect().width * (activeColNumber > 5 ? 30 : 50)) / 100 + 'px'
					: activeColNumber > 5
					? '30%'
					: '50%'
				: null;
		const hasRightToViewColumn = col => (col.name === 'id' || col.checked) && col.name !== 'completionBar';

		return (
			<section className={'app-main overview-section useNewNavigation'}>
				{this.state.loadingSection ? <UploadingOverlay /> : null}
				{this.props.children}
				{this.getHeaderTitle()}
				{this.getHeader(columns)}
				<div
					className={'section-body all-projects-section' + (this.props.buyNowTime ? ' show-trial-footer' : '')}
					data-cy={'projects-page'}
				>
					{(this.props.viewer.projectGroups && this.props.viewer.projectGroups.edges.length !== 0) ||
					(this.props.viewer.projects && this.props.viewer.projects.edges.length !== 0) ? (
						<div
							className={
								'all-projects useNewNavigation ' +
								(this.state.displayMode === 'list' ? ' list-view' : ' grid-view') +
								(overflowingList ? ' overflowing-list' : '')
							}
						>
							<CustomScrollToNativeScroll className="custom-scrollbar-div" hasFocusableContent isPageScroller>
								<div className="scrollable" ref={div => (this.scrollable = div)}>
									{projects.length !== 0 ? (
										this.project_statuses.map((project_status, sectionIndex) => (
											<div className={'project-status-section-wrapper'} key={sectionIndex}>
												<button
													className={
														'project-status-section-title' +
														(overflowingList ? ' overflowing-list' : '')
													}
													onClick={this.toggleProjectStatusSection.bind(this, project_status)}
												>
													<span className="title" data-cy={this.getSectionTitle(project_status)}>
														{this.getSectionTitle(project_status)}
													</span>
													{`(${this.getProjectStatusSectionCount(
														projects,
														project_status,
														this.state.lazyDataFetched
													)})`}
													<div
														className={
															'arrow ' +
															(this.state.projectStatusSectionExpandedMap.get(project_status)
																? 'expanded'
																: 'collapsed')
														}
													/>
												</button>
												{this.state.projectStatusSectionExpandedMap.get(project_status) ? (
													!this.isStatusSectionReady(project_status, this.state.lazyDataFetched) ? (
														<InlineLoader />
													) : projects.filter(
															project =>
																(!project.node.projects &&
																	stageGroupKeyOf(project.node) === project_status) ||
																(project.node.projects &&
																	this.hasAnyProjectsInProjectStatusSection(
																		project,
																		project_status
																	))
													  ).length === 0 ? null : this.state.displayMode === 'list' ? (
														<table
															className={
																'project-list-table' +
																(this.state.listOverflowWidth !== null
																	? ''
																	: ' not-overflowing')
															}
															style={customFieldColumnsTableStyle(shownCustomFields.length)}
															data-cy={'project-list-table-' + project_status}
															ref={el => (this.table = el)}
														>
															<thead className={'table-header'}>
																<tr>
																	{this.state.columns.map(col =>
																		hasRightToViewColumn(col) ? (
																			<th
																				title={
																					col.name === 'id'
																						? 'ID'
																						: formatMessage({id: col.translationId})
																				}
																				key={col.name}
																				ref={el => {
																					if (col.name === 'name') {
																						this.nameHeader = el;
																					}
																				}}
																				className={
																					'sortable ' +
																					(col.name === 'id' ? 'id-column ' : '') +
																					(this.state.sortBy.column === col.name
																						? this.state.sortBy.ascending
																							? 'ascending'
																							: 'descending'
																						: '') +
																					(col.name === 'statusColor' ||
																					col.name === 'completion' ||
																					col.name === 'dates'
																						? ' center-text'
																						: '') +
																					(this.NUMERIC_COLUMNS.includes(col.name)
																						? ' numeric'
																						: '')
																				}
																				onClick={this.setSortBy.bind(this, col.name)}
																				style={
																					col.name === 'name'
																						? {
																								minWidth:
																									projectNameColumnWidth,
																								width: projectNameColumnWidth,
																								maxWidth:
																									projectNameColumnWidth,
																						  }
																						: col.name === 'client'
																						? {
																								minWidth: '140px',
																								width: '140px',
																								maxWidth: '140px',
																						  }
																						: col.name === 'startDate' ||
																						  col.name === 'endDate'
																						? {
																								minWidth: '110px',
																								width: '110px',
																								maxWidth: '110px',
																						  }
																						: {
																								minWidth: this.getColumnWidth(
																									col.name
																								),
																						  }
																				}
																			>
																				{col.name === 'id' ? (
																					col.checked ? (
																						'ID'
																					) : (
																						''
																					)
																				) : col.name.includes('xero') ? (
																					<div className="header-name-icon-wrapper">
																						{formatMessage({id: col.translationId})}{' '}
																						(Xero)
																						<span>&nbsp;&nbsp;</span>
																					</div>
																				) : (
																					formatMessage({id: col.translationId})
																				)}
																				{!col.name.includes('xero') ? (
																					this.state.sortBy.column === col.name ? (
																						<span>&nbsp;&nbsp;</span>
																					) : null
																				) : null}
																			</th>
																		) : null
																	)}
																	{shownCustomFields.map(definition => (
																		<ProjectCustomFieldHeaderCell
																			key={definition.id}
																			definition={definition}
																			sortBy={this.state.sortBy}
																			onSort={this.setSortBy.bind(this)}
																		/>
																	))}
																</tr>
															</thead>
															<tbody>
																<LoadMore
																	key="query-render-projects-in-state"
																	query={projectsLoaderQuery}
																	loader={
																		<ProjectsLoader
																			projectFromOutside={this.props.viewer.projects}
																			projectGroupsFromOutside={
																				this.props.viewer.projectGroups
																			}
																			calculatedDataMap={this.calculatedDataMap}
																			project_status={project_status}
																		/>
																	}
																	customLoader={() => <InlineLoader />}
																>
																	{({data: projectsData}) => {
																		projectsData = filterProjects(
																			projectsData,
																			this.state.searchFilterValue,
																			this.state.filters,
																			this.state.filterFunctions,
																			this.calculatedDataMap
																		);
																		projectsData = sortProjects(
																			projectsData,
																			this.state.sortBy,
																			this.calculatedDataMap,
																			this.getCustomFieldDefinitions()
																		);
																		return projectsData.map(project => {
																			if (project.node.projects) {
																				return this.getGroupHTML(
																					project_status,
																					project,
																					nameStyle,
																					projectNameColumnWidth,
																					hasFinancialAccess,
																					shownCustomFields,
																					customFieldFormat
																				);
																			} else {
																				// prettier-ignore
																				const lineItem = (
																					<ProjectListProjectLineItem
																						project={project}
																						key={project.id}
																						nameStyle={nameStyle}
																						columns={this.state.columns}
																						xeroEnabled={this.props.viewer.company.xeroEnabled}
																						selectedMenuItem={this.state.selectedMenuItem}
																						searchFilterValue={this.state.searchFilterValue}
																						filterChanged={this.state.filterChanged}
																						projectNameColumnWidth={projectNameColumnWidth}
																						calculatedDataMap={new Map(this.calculatedDataMap)}
																						shouldRecalculateCompletionBarWidth={this.state.shouldRecalculateCompletionBarWidth}
																						resetShouldRecalculateCompletionBarWidth={this.resetShouldRecalculateCompletionBarWidth.bind(this)}
																						hasFinancialAccess={hasFinancialAccess}
																						customFieldColumns={shownCustomFields}
																						customFieldFormat={customFieldFormat}
																					/>
																				);
																				// prettier-ignore
																				return (
																					<ReactVisibilitySensor
																						partialVisibility={true}
																						offset={{ top: -200, bottom: -200 }}
																						key={project.node.id}
																					>
																						{({ isVisible }) => {
																							return isVisible ? (
																								lineItem
																							) : (
																								<tr style={{ height: '40px' }} />
																							);
																						}}
																					</ReactVisibilitySensor>
																				)
																			}
																		});
																	}}
																</LoadMore>
															</tbody>
														</table>
													) : (
														<div className="project-cards v2" data-cy="projects-containers">
															{projects
																.filter(
																	p =>
																		p.node.projects &&
																		this.hasAnyProjectsInProjectStatusSection(
																			p,
																			project_status
																		)
																)
																.map((projectGroup, index) =>
																	this.getProjectGroupHTML(
																		project_status,
																		projectGroup,
																		index,
																		index ===
																			projects.filter(
																				p =>
																					p.node.projects &&
																					this.hasAnyProjectsInProjectStatusSection(
																						p,
																						project_status
																					)
																			).length -
																				1
																	)
																)}
															{projects
																.filter(
																	p =>
																		!p.node.projects &&
																		stageGroupKeyOf(p.node) === project_status
																)
																.map((project, index) => (
																	<div key={index}>
																		<ProjectListProjectCard
																			cardLayoutDisplay={this.state.cardLayoutDisplay}
																			project={project}
																			index={index}
																			includeWrapper={
																				this.state.numberOfProjectTilesAfterLastGroupMap.has(
																					project_status
																				) &&
																				this.state.numberOfProjectTilesAfterLastGroupMap.get(
																					project_status
																				) >=
																					index + 1
																			}
																			projectCardHeight={this.state.projectSectionCardHeightMap.get(
																				project_status
																			)}
																			calculatedDataMap={this.calculatedDataMap}
																			hasTimeApproval={this.hasTimeApproval}
																		/>
																	</div>
																))}
														</div>
													)
												) : null}
											</div>
										))
									) : this.state.searchFilterValue !== '' ||
									  hasActiveFilters ||
									  (this.state.filters?.project && Object.keys(this.state.filters.project).length > 0) ? (
										<ProjectListDoneProjectsEmptyState
											infoMessageId={infoMessageId}
											searchText={this.state.searchFilterValue}
											canAddProjects={false}
										/>
									) : (
										<ProjectListDoneProjectsEmptyState
											infoMessageId={infoMessageId}
											addProject={this.handleAddProjectFromEmptyState.bind(this)}
											canAddProjects={
												canAddProjects &&
												this.state.selectedMenuItem !== 'HALTED' &&
												this.state.selectedMenuItem !== 'DONE'
											}
										/>
									)}
								</div>
							</CustomScrollToNativeScroll>
						</div>
					) : hasPermission(PERMISSION_TYPE.PROJECTS_CREATE) ? (
						<EmptyState pageName={EMPTY_STATE.PROJECTS} />
					) : (
						<EmptyState pageName={EMPTY_STATE.PROJECTS_COLLABORATOR} />
					)}
				</div>
			</section>
		);
	}
}

const ProjectListPageQuery = graphql`
	query ProjectListPage_Query(
		$excludeDoneOrHalted: Boolean!
		$excludeGroupProjectsFromProjectConnection: Boolean!
		$loadCustomFields: Boolean!
	) {
		viewer {
			actualPersonId
			component(name: "overview_projects")
			...ProjectListPage_viewer
				@arguments(
					excludeDoneOrHalted: $excludeDoneOrHalted
					excludeGroupProjectsFromProjectConnection: $excludeGroupProjectsFromProjectConnection
					loadCustomFields: $loadCustomFields
				)
		}
	}
`;

export {ProjectListPageQuery, ProjectListPage};

// Company-level custom field definitions enabled for the Projects list. Same selection as
// OpportunitiesList_customFieldDefinitions so toCustomFieldColumnDefs accepts it unchanged. Spread behind
// @include(if: $loadCustomFields) so the gated-off request carries no custom field selection.
graphql`
	fragment ProjectListPage_customFieldDefinitions on Company {
		projectListCustomFieldDefinitions: customFieldDefinitionsV2(first: 1000, list: PROJECT_LIST) {
			edges {
				node {
					id
					key
					displayName
					type
					... on TextCustomField {
						readOnly
					}
					... on IntegerCustomField {
						readOnly
					}
					... on DecimalCustomField {
						readOnly
					}
					... on DateCustomField {
						readOnly
					}
					... on DropdownCustomField {
						options {
							id
							displayName
						}
					}
				}
			}
		}
	}
`;

// Per-project custom field values for the Projects list: only the fields that are set, so a field with no entry is
// an empty cell. Aliased so it cannot
// collide with another customFields selection on the same node.
graphql`
	fragment ProjectListPage_customFieldValues on ProjectType {
		projectListCustomFields: customFields(first: 1000, list: PROJECT_LIST) {
			edges {
				node {
					key
					value
				}
			}
		}
	}
`;

graphql`
	fragment ProjectListPage_projectGroup on ProjectGroupType {
		id
		companyProjectGroupId
		name
		color
		projects(first: 1000000) {
			edges {
				node {
					id
					stage {
						id
						name
						profile
					}
					name
					budgetType
					isInProjectGroup
					readOnlyAccess
					# used in card layout
					description
					projectStartDay
					projectStartMonth
					projectStartYear
					projectEndDay
					projectEndMonth
					projectEndYear

					# used in search
					companyProjectId
					customProjectId
					client {
						id
						name
					}
					rateCard {
						id
					}
					projectLabels(first: 10000) {
						edges {
							node {
								label {
									id
								}
							}
						}
					}
					# used for filtering
					projectColor
					currentProjectStatus {
						id
						color
						person {
							firstName
							lastName
						}
					}
					priorityLevel {
						id
						name
						weight
					}
					projectPersons(first: 1000000, contactsOnly: true) {
						edges {
							node {
								id
								isContactPerson
								person {
									id
									# used for card layout
									firstName
									lastName
									profilePictureId
									profilePictureDefaultId
									initials
								}
							}
						}
					}
				}
			}
		}
	}
`;

export default withSocketHandling(
	injectIntl(
		withRouter(
			createRefetchContainer(
				ProjectListPage,
				{
					viewer: graphql`
						fragment ProjectListPage_viewer on Viewer
						@argumentDefinitions(
							excludeDoneOrHalted: {type: "Boolean!"}
							excludeGroupProjectsFromProjectConnection: {type: "Boolean!"}
							loadCustomFields: {type: "Boolean!"}
						) {
							id
							backendId
							firstName
							language
							actualPersonId
							availableFeatureFlags {
								key
							}
							client {
								id
							}
							filters(first: 1000000, filterSection: PROJECTS_OVERVIEW)
								@connection(key: "Viewer_filters", filters: []) {
								edges {
									node {
										id
										name
										section
										value
										updatedAt
									}
								}
							}
							company {
								xeroEnabled
								sageIntacctConnectionEnabled
								sageIntacctTimeRegsFromForecast
								priorityLevels {
									edges {
										node {
											id
										}
									}
								}
								...ProjectListPage_customFieldDefinitions @include(if: $loadCustomFields) @relay(mask: false)
							}
							projectGroups(first: 1000000, excludeDoneOrHalted: $excludeDoneOrHalted)
								@connection(key: "Viewer_projectGroups", filters: []) {
								edges {
									node {
										...ProjectListPage_projectGroup @relay(mask: false)
										projects(first: 1000000) {
											edges {
												node {
													id
													...ProjectsLoader_project @relay(mask: false)
													...ProjectListPage_customFieldValues
														@include(if: $loadCustomFields)
														@relay(mask: false)
												}
											}
										}
									}
								}
							}
							projects(
								first: 1000000
								excludeRestricted: true
								excludeGroupProjects: $excludeGroupProjectsFromProjectConnection
								excludeDoneOrHalted: $excludeDoneOrHalted
							) @connection(key: "Viewer_projects", filters: []) {
								edges {
									node {
										id
										...ProjectsLoader_project @relay(mask: false)
										name
										budgetType
										stage {
											id
											name
											profile
										}
										isInProjectGroup
										readOnlyAccess
										# used in card layout
										description
										projectStartDay
										projectStartMonth
										projectStartYear
										projectEndDay
										projectEndMonth
										projectEndYear
										# used in search
										companyProjectId
										customProjectId
										...ProjectListPage_customFieldValues @include(if: $loadCustomFields) @relay(mask: false)
										client {
											id
											name
										}
										rateCard {
											id
										}
										projectLabels(first: 10000) {
											edges {
												node {
													label {
														id
													}
												}
											}
										}
										# used for filtering
										projectColor
										currentProjectStatus {
											id
											color
											person {
												firstName
												lastName
											}
										}
										priorityLevel {
											id
											name
											weight
										}
										projectPersons(first: 1000000, contactsOnly: true) {
											edges {
												node {
													id
													isContactPerson
													person {
														id
														# used for card layout
														firstName
														lastName
														profilePictureId
														profilePictureDefaultId
														initials
													}
												}
											}
										}
									}
								}
							}
						}
					`,
				},
				graphql`
					query ProjectListPage_RefetchQuery(
						$excludeDoneOrHalted: Boolean!
						$excludeGroupProjectsFromProjectConnection: Boolean!
						$loadCustomFields: Boolean!
					) {
						viewer {
							actualPersonId
							component(name: "overview_projects_refetch")
							...ProjectListPage_viewer
								@arguments(
									excludeDoneOrHalted: $excludeDoneOrHalted
									excludeGroupProjectsFromProjectConnection: $excludeGroupProjectsFromProjectConnection
									loadCustomFields: $loadCustomFields
								)
						}
					}
				`
			)
		)
	)
);
